import styled, { css } from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'
import { resolveResponsiveProp } from 'styles/mixins'
import { Spacing, spacingMixin } from 'styles/spacing'

interface GridProps extends Spacing {
    gap: number | [number, number]
    columns: number | [number, number]
    hasEvenColumns?: boolean
}

const Grid = styled.div<GridProps>`
    display: grid;
    width: 100%;

    ${({ gap }) =>
        resolveResponsiveProp({
            type: 'grid-gap',
            value: gap,
            unit: 'px',
        })}

    ${({ columns, hasEvenColumns }) => {
        const isArray = Array.isArray(columns)

        return css`
            grid-template-columns: ${`repeat(${
                isArray ? columns[0] : columns
            }, ${hasEvenColumns ? 'minmax(0, 1fr)' : 'auto'})`};

            @media ${respondAbove.xl} {
                grid-template-columns: ${`repeat(${
                    isArray ? columns[1] : columns
                }, ${hasEvenColumns ? 'minmax(0, 1fr)' : 'auto'})`};
            }
        `
    }}

    ${spacingMixin}
`
export default Grid
